import Component from 'flarum/common/Component';
import Stream from 'flarum/utils/Stream';
import showAlert from '../common/util/showAlert';

export default class UploadComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.disabled = this.attrs.disabled;
    this.uploadingFile = false;
    this.uploadType = this.attrs.uploadType;
    this.uploadTarget = this.attrs.uploadTarget;
    this.uploadLimit = parseInt(this.attrs.uploadLimit) || 0;
    this.uploadCallback = this.attrs.uploadCallback;
    this.viewType = this.attrs.viewType || "normal";
  }

  onupdate(){
    const viewType = this.attrs.viewType || "normal";

    if(viewType!==this.viewType){
      this.viewType = viewType;
      m.redraw();
    }
  }

  view() {
    let attachmentUploadCount = 0;

    return (
      <div>
        {(this.viewType==="normal" || this.viewType==="edit") && (
          <div>
            <div id={this.uploadType} className="u2diUserSubmitCategoryItemUpload" style="width:44px" onclick={(e) => {
              this.uploadItemImage(e,this.uploadType);
            }}><i style={this.disabled===true?"color:gray":""} className="fas fa-upload"></i></div>

            <div style={Object.keys(this.uploadTarget()).length>0?"padding-top: 10px;padding-bottom: 15px;":"padding-top: 10px;padding-bottom: 0px;"} className="u2diUserSubmitCategoryItems">
              <div className="u2diUserSubmitCategoryItemUploadContainer">
                {this.uploadTarget().map((uploadFileData) => {
                  const uploadFilePath = uploadFileData.path;
                  const uploadFileName = uploadFileData.name;

                  attachmentUploadCount++;
                  return (
                    <div>
                      {this.getUploadItemContainer(attachmentUploadCount,uploadFilePath,uploadFileName)}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}

        {(this.viewType==="read" && this.uploadTarget().length===0) && (
          <div style="margin-top: -10px;">
            {app.translator.trans('ziven-u2di.forum.item-upload-empty')}
          </div>
        )}

        {(this.viewType==="read" && this.uploadTarget().length>0) && (
          <div className="u2diUserSubmitCategoryItems">
            <div className="u2diUserSubmitCategoryItemUploadContainer">
              {this.uploadTarget().map((uploadFileData) => {
                const uploadFilePath = uploadFileData.path;
                const uploadFileName = uploadFileData.name;

                attachmentUploadCount++;
                return (
                  <div>
                    {this.getUploadItemContainer(attachmentUploadCount,uploadFilePath,uploadFileName)}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    );
  }

  checkFileType(url) {
    let output = /\.(jpg|jpeg|png|bmp|gif)$/.test(url)?"image":"";

    if(output===""){
      output = /\.(pdf)$/.test(url)?"pdf":"";
    }

    if(output===""){
      output = /\.(dwg)$/.test(url)?"dwg":"other";
    }

    return output;
  }

  previewUploadImage(uploadFilePath,uploadFileName){
    $("#u2diUploadPreviewModal").css("display","flex");
    $("#u2diUploadPreviewModal-content").attr("src", uploadFilePath);
    $("#u2diUploadPreviewModal-caption").text(uploadFileName);
  }

  getUploadItemContainer(uploadCount,uploadFilePath,uploadFileName){
    const fileType = this.checkFileType(uploadFilePath);

    if(this.viewType==="normal" || this.viewType==="edit"){
      if(uploadFilePath==="uploading"){
        const style = "display: flex;position: relative;align-items: center;justify-content: center;";

        return (
          <div className='u2diUploadItemContainer' style={style}>{app.translator.trans("ziven-u2di.lib.uploading")}</div>
        );
      }else{
        if(fileType==="image"){
          const style = "cursor: pointer;background: url("+uploadFilePath+");background-size: cover;background-position: center;background-repeat: no-repeat;position:relative";

          return (
            <div>
              <div className='u2diUploadItemContainer' style={style}>
                <div className="u2diCloseCircle" onclick={(e) => { this.deleteUploadItem(uploadCount) }}>
                  <i class="fas fa-times"></i>
                </div>
                <div onclick={(e) => { this.previewUploadImage(uploadFilePath,uploadFileName) }} style="width: 100%;height: 80%;margin-top: 18px;color: transparent;">image</div>
              </div>
              <div style="width:80px" className="u2diEllipsisArea">{uploadFileName}</div>
            </div>
          );
        }else{
          const style = "cursor: pointer;display: flex;position: relative;align-items: center;justify-content: center;";

          return (
            <div>
                <div className='u2diUploadItemContainer' style={style}>
                  <div className="u2diCloseCircle" onclick={(e) => { this.deleteUploadItem(uploadCount) }}>
                    <i class="fas fa-times"></i>
                  </div>
                  <a href={uploadFilePath} target="_blank">
                    <div style="text-align: center;">
                      <div><i style="font-size: 30px;" className={fileType==="pdf"?"fas fa-file-pdf":"fas fa-file-archive"}></i></div>
                      <div>{fileType.toUpperCase()}</div>
                    </div>
                  </a>
                </div>
              <div style="width:80px" className="u2diEllipsisArea">{uploadFileName}</div>
            </div>
          );
        }
      }
    }else{
      if(fileType==="image"){
        const style = "cursor: pointer;background: url("+uploadFilePath+");background-size: cover;background-position: center;background-repeat: no-repeat;position:relative";

        return (
            <div>
              <div className='u2diUploadItemContainer' onclick={(e) => { this.previewUploadImage(uploadFilePath,uploadFileName) }} style={style}>
                <div style="width: 100%;height: 80%;margin-top: 18px;color: transparent;">image</div>
              </div>
              <div style="width:80px" className="u2diEllipsisArea">{uploadFileName}</div>
            </div>
        );
      }else{
        const style = "cursor: pointer;display: flex;position: relative;align-items: center;justify-content: center;";

        return (
          <div>
            <div className='u2diUploadItemContainer' style={style}>
              <a href={uploadFilePath} target="_blank">
                <div style="text-align: center;">
                  <div><i style="font-size: 30px;" className={fileType==="pdf"?"fas fa-file-pdf":"fas fa-file-archive"}></i></div>
                  <div>{fileType.toUpperCase()}</div>
                </div>
              </a>
            </div>
            <div style="width:80px" className="u2diEllipsisArea">{uploadFileName}</div>
          </div>
        );
      }
    }
  }

  deleteUploadItem(uploadItemID){
    (this.uploadTarget()).splice(uploadItemID-1,1);
    this.uploadCallback(true,this.uploadTarget);
  }

  uploadItemImage(e,uploadType){
    //
    e.preventDefault();

    if(this.uploadingFile===true || this.disabled===true){
      return;
    }

    if(this.uploadLimit>0 && this.uploadTarget().length>=this.uploadLimit){
      showAlert(app.translator.trans('ziven-u2di.forum.error-upload-limited-reached',{count:this.uploadLimit}));
      return;
    }

    const $input = $('<input type="file">');
    const _this = this;

    $input.appendTo('body').hide().trigger('click').on('change', event => {
      const file = event.target.files[0];
      const filename = file.name;
      const splitFilename = filename.split(".");
      const fileExt = (splitFilename[splitFilename.length-1]).toLowerCase();

      if(fileExt==="dwg"){
        _this.doUpload(_this,uploadType,file,filename);
      }else if(fileExt==="pdf"){
        // window.PDFLib
        var fileReader = new FileReader();
        var base64;
        fileReader.onload = function(fileLoadedEvent) {
            base64 = fileLoadedEvent.target.result;

            async function modifyPdf(base64) {
              const PDFDocument = window.PDFLib.PDFDocument;
              const pdfDoc = await PDFDocument.load(base64);
              const degrees = window.PDFLib.degrees;

              const pngUrl = 'assets/extensions/ziiven-u2di/promotionImageLogo.png';
              const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());
              const pngImage = await pdfDoc.embedPng(pngImageBytes);
              const pages = pdfDoc.getPages();

              for(let index in pages){
                const page = pages[index];
                const pngDims = pngImage.scale(1);
  
                const pageWidth = page.getWidth();
                const pageHeight = page.getHeight();
                const pngWidth = pngDims.width;
                const pngHeight = pngDims.height;
  
                const pngResizedWidth = pageWidth * 0.66;
                const pngResizedHeight = (pngResizedWidth/pngWidth) * pngHeight;
  
                page.drawImage(pngImage, {
                  x: (pageWidth-pngResizedWidth)/2,
                  y: (pageHeight+pngResizedHeight)/2,
                  width: pngResizedWidth,
                  height: pngResizedHeight,
                  rotate: degrees(-30),
                  opacity: 0.6,
                })
              }
            
              const pdfBytes = await pdfDoc.save();
              const pdfBlob = new Blob([pdfBytes], {type: 'application/pdf'});
              
              _this.doUpload(_this,uploadType,pdfBlob,filename);
            }
            
            modifyPdf(base64);
        };
        // Convert data to base64
        fileReader.readAsDataURL(file);
      }else{
        watermark([file, 'assets/extensions/ziiven-u2di/promotionImageLogo.png'])
        .image((uploadImage, logo) => {
          const context = uploadImage.getContext('2d');
          const originalWidth = 452;
          const originalHeight = 90;
          const rotation = 30;
          const canvas = context.canvas;
          const logoResizedWidth = canvas.width*0.66;
          const logoResizedHeight = (logoResizedWidth/originalWidth) * originalHeight;
          const posX = (uploadImage.width - logoResizedWidth) / 2;
          const posY = (uploadImage.height - logoResizedHeight) / 2;
  
          context.save();
          context.globalAlpha = 0.6;
          context.translate(canvas.width/2, canvas.height/2);
          context.rotate(rotation*Math.PI/180);
          context.translate(-canvas.width/2, -canvas.height/2);
          context.drawImage(logo, posX,posY, logoResizedWidth, logoResizedHeight);
  
          context.restore();
          return uploadImage;
        })
        .then(function (img) {
          _this.resizeImage(img,file,fileExt,function(dataurl){
            const file_watermark = _this.DataURIToBlob(dataurl);
            _this.doUpload(_this,uploadType,file_watermark,filename);
          });
        });
      }

    });
  }

  doUpload(_this,uploadType,file,filename){
    let option_target = _this.uploadTarget;

    const body = new FormData();
    body.append('u2diFile', file,filename);
    body.append('u2diFileFrom', "submitType1"+uploadType);
    _this.uploadingFile = true;
    option_target().push("uploading");

    app.request({
      url: `${app.forum.attribute('apiUrl')}/u2diFileUpload`,
      method: 'POST',
      body,
    }).then(response => {
      let uploadFilePath = response.path;
      let option_temp = option_target();
      option_temp.pop();
      option_temp.push({path:uploadFilePath,name:filename});

      option_target(option_temp);
      _this.uploadingFile = false;
      _this.uploadCallback(true,option_target);
      m.redraw();

    }, error => {
      _this.uploadingFile = false;
      option_target().pop();
      _this.uploadCallback(false,option_target);
      m.redraw();
      throw error;
    });
  }

  resizeImage(img,file,fileExt,callback){
    let reader = new FileReader();
    let fileImage;

    reader.readAsDataURL(file);
    reader.onload = function(e) {
      // img.src = e.target.result;
  
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
  
      var MAX_WIDTH = app.forum.attribute("uploadWidthResize");
      var width = img.width;
      var height = img.height;
  
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;

        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
    
        callback(canvas.toDataURL(fileExt==="png"?"image/png":"image/jpeg"));
      }else{
        callback(img.src);
      }
    }
  }

  DataURIToBlob(dataURI) {
    const splitDataURI = dataURI.split(',')
    const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
    const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

    const ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++)
        ia[i] = byteString.charCodeAt(i)

    return new Blob([ia], { type: mimeString })
  }
}